import Notification                 from 'scripts/defa/notifications/model-notification';
import Notifications                from 'scripts/defa/notifications/collection-notifications';
import NotificationCollectionView   from 'scripts/defa/notifications/view-notification-collection-view';
import NotificationView             from 'scripts/defa/notifications/view-notification-view';
import NotificationContainer        from 'scripts/defa/notifications/view-notifications-container';
import NotificationsMenuView        from 'scripts/defa/notifications/view-notifications-menu-view';


import Module                           from 'scripts/module';

const NotificationsModule = new Module('NotificationsModule',{
	collections: {
		Notifications,
	},

	models     : {
		Notification,
	},

	views      : {
		NotificationCollectionView,
		NotificationView,
		NotificationContainer,
		NotificationsMenuView,

	}
});
export default NotificationsModule;